import React from "react";
import { useField } from "formik";
import { Col, Form } from "react-bootstrap";

const ImageInput = ({ label, shouldShowError, onChange, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <Form.Group as={Col} md="6" controlId={props.id || props.name}>
            <div className="pb-1">{label}</div>
            <div className="d-flex position-relative bg-light align-items-center justify-content-center" style={{ height: "248px" }}>
                {
                    field.value &&
                    <img
                        src={field.value instanceof File ? URL.createObjectURL(field.value) : field.value}
                        width="100%"
                        height="100%"
                        style={{ objectFit: "contain" }}
                    />
                }
                <label
                    htmlFor={props.id || props.name}
                    className="btn btn-dark m-3"
                    style={{
                        left: 0,
                        bottom: 0,
                        position: "absolute",
                        zIndex: 1,
                    }}
                >
                    Edit
                </label>
                <input id={props.id || props.name} type={"file"} onChange={onChange} accept=".jpg, .jpeg, .png" />
            </div>

            {shouldShowError || (meta.touched && meta.error) ? (
                <div className="text-danger">{meta.error}</div>
            ) : null}
        </Form.Group>
    );
};

export default ImageInput;